/** @internal App-side build version, surfaced to consumers as `artis.v1.version.app`. */
export const SHELL_VERSION = "0.10.0";
//# sourceMappingURL=version.js.map